import { collectDeviceIdentity } from '../core/devices/deviceIdentity';
import { resolveDevicePlatform } from '../adapters/device/platformDetector';
import { usesFirebaseAuth } from './FirebaseAuthService';
import { callFunction } from './firebase/FunctionsService';

export async function registerLoginDeviceOnSignIn() {
  if (!usesFirebaseAuth()) return { allowed: true, skipped: true };

  const platform = await resolveDevicePlatform();
  const identity = collectDeviceIdentity(platform);
  return callFunction('registerLoginDevice', identity);
}

export async function listStaffLoginDevices(targetUid: string, houseId?: string) {
  const result = await callFunction('listStaffLoginDevices', { targetUid, houseId });
  return (result as { devices?: unknown[] })?.devices ?? [];
}

export async function setStaffLoginDeviceTrust(payload: {
  targetUid: string;
  deviceId: string;
  trusted?: boolean;
  blocked?: boolean;
}) {
  const result = await callFunction('setStaffLoginDeviceTrust', payload);
  return (result as { device?: unknown })?.device;
}
